export default __webpack_public_path__ + "static/media/martin_luuna.cd36cc72.png";